import {createFeatureSelector, createSelector} from "@ngrx/store";
import {SelectorUtil} from "@app-web-central/web/shared/utils";
import {usersFeatureKey, UsersState} from "./users.reducer";

export const getUsersState = createFeatureSelector<UsersState>(usersFeatureKey);

export const getUsers = createSelector(getUsersState, (state) => state.data);
export const getUsersLoading = createSelector(getUsersState, SelectorUtil.isLoading);
